export const testimonials = {
  title: "Ce que disent les familles",
  subtitle: "Témoignages de notre communauté éducative",
  items: [
    {
      quote: "Gándara allie les principes Montessori avec flexibilité, respect et joie. Nos enfants se sentent heureux, en sécurité et curieux chaque jour, et nous envisageons l'avenir en toute sérénité.",
      author: "Alba & Marc",
      role: "Famille Gándara"
    },
    {
      quote: "Nous cherchions une école Montessori, internationale et où nos filles seraient vraiment heureuses. À Gándara, nous avons trouvé tout cela et bien plus encore.",
      author: "Patri & Pablo",
      role: "Famille Gándara"
    },
    {
      quote: "Gándara est un lieu sûr où les enfants grandissent respectés et accompagnés. L'équipe enseignante est sensible et comprend véritablement chaque enfant.",
      author: "Marie",
      role: "Famille Gándara"
    }
  ]
};
